module.exports = __webpack_public_path__ + "static/media/order.a0c6f691.svg";